import { attributesEmbedSchema } from "../../elements/embed/attributes.js";
import { guideEmbedHtml } from "../../elements/embed/component.js";
import { validate } from "../../helpers/validate.js";
import { ScalarEmbedVue } from "../../elements/embed/component.js";
const scalarEmbed = {
  name: "scalar-embed",
  tagName: "scalar-embed",
  tiptapName: "custom_embed",
  attributeTransform: (content, attrs) => {
    const isMissingCaption = attrs.caption === void 0;
    return validate(attributesEmbedSchema, {
      ...attrs,
      ...isMissingCaption ? { caption: content } : {}
    });
  },
  render: async (props) => {
    const validated = validate(attributesEmbedSchema, props);
    return validated ? guideEmbedHtml(validated) : "";
  }
};
export {
  ScalarEmbedVue,
  scalarEmbed
};
//# sourceMappingURL=index.js.map
